import * as React from 'react'
import { AggregatedError } from '../domain/history/AggregatedError'
import Link from '../helper/link'
import Shorten from '../helper/shorten'
import { Box, BoxBody } from '../ui/box'

interface Props {
    errors: AggregatedError[]
}

export class ErrorSummary extends React.PureComponent<Props> {
    public render() {
        return (
            <Box>
                <BoxBody noPadding>
                    {this.props.errors.map(error => (
                        <div key={error.errorId} className="error-item">
                            <Link route="XhprofErrorBundle.Issues.errors" params={{ error: error.errorId, offset: 0 }}>
                                <div className="error-item-type">
                                    <small
                                        data-toggle="tooltip"
                                        title={error.occurrences + ' occurrences in total'}
                                        className="label label-outline-default"
                                    >
                                        {error.occurrences}x
                                    </small>
                                    <span title={error.type}>
                                        <Shorten string={error.type} />
                                    </span>
                                </div>
                                <div className="error-item-source">{error.source}</div>
                            </Link>
                        </div>
                    ))}
                    {this.props.errors.length === 0 && <div className="text-center mb-1">No Errors recorded</div>}
                </BoxBody>
            </Box>
        )
    }
}
